//
// Input helpers
//
// Helper functions to add common functionality to buttons

InputHelpers = {};

InputHelpers.addRecoveryFlag = function (button) {
  button._flags.inRecovery = false;

  button.recoveryStart = function () {
    this._flags.inRecovery = true;
  };

  button.recoveryEnd = function () {
    this._flags.inRecovery = false;
  };

  messageBus.subscribe("common:RecoverGame", button.recoveryStart.bind(button));
  messageBus.subscribe(
    "common:GameCompleteEvent",
    button.recoveryEnd.bind(button)
  );
};

InputHelpers.addAutoplayFlag = function (button) {
  button._flags.autoplayStarted = false;

  button.autoplayStarted = function (autoplayData) {
    this._flags.autoplayStarted = true;
  };

  button.autoplayEnded = function (autoplayData) {
    this._flags.autoplayStarted = false;
  };

  messageBus.subscribe("autoplay:started", button.autoplayStarted.bind(button));
  messageBus.subscribe("autoplay:ended", button.autoplayEnded.bind(button));
};

InputHelpers.addAutoplayPlatformEnabledFlag = function (button) {
  button._flags.autoplayPlatformEnabled = false;
  button._flags.autoplayPlatformVisible = false;

  button.onAutoplayConfig = function (gameConfig) {
    this._flags.autoplayPlatformEnabled =
      gameConfig.data.uiElements.btnAutoplay.enabled;
    this._flags.autoplayPlatformVisible =
      gameConfig.data.uiElements.btnAutoplay.visible;
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onAutoplayConfig.bind(button)
  );
};

InputHelpers.addSkipWinPlatformEnabledFlag = function (button) {
  button._flags.skipWinPlatformEnabled = false;
  button._flags.skipWinPlatformVisible = false;

  button.onSkipWinConfig = function (gameConfig) {
    this._flags.skipWinPlatformEnabled =
      gameConfig.data.uiElements.btnSkip.enabled;
    this._flags.skipWinPlatformVisible =
      gameConfig.data.uiElements.btnSkip.visible;
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onSkipWinConfig.bind(button)
  );
};

InputHelpers.addInfoPlatformEnabledFlag = function (button) {
  button._flags.infoPlatformEnabled = false;
  button._flags.infoPlatformVisible = false;

  button.onInfoConfig = function (gameConfig) {
    this._flags.infoPlatformEnabled =
      gameConfig.data.uiElements.btnInfo.enabled;
    this._flags.infoPlatformVisible =
      gameConfig.data.uiElements.btnInfo.visible;
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onInfoConfig.bind(button)
  );
};

InputHelpers.addCanSpinFlag = function (button) {
  button._flags.canSpin = false;

  button.readyToStart = function () {
    this._flags.canSpin = true;
  };

  button.spinStarted = function (spinTask) {
    this._flags.canSpin = false;
  };

  button.gameCommitted = function () {
    this._flags.canSpin = false;
  };

  messageBus.subscribe("common:ReadyToStart", button.readyToStart.bind(button));
  messageBus.subscribe("spinner:SpinEvent", button.spinStarted.bind(button));
  messageBus.subscribe(
    "common:GameCommitted",
    button.gameCommitted.bind(button)
  );
};

InputHelpers.addGenerics = function (button) {
  button._flags = button.flags || {};

  button.canEnable = function () {
    return !button._flags.modal.active;
  };

  button.canShow = function () {
    return true;
  };

  button.enableButton = function () {
    if (this.canEnable()) {
      this.button.enableButton(true);
    } else {
      this.disableButton();
    }
  };

  button.disableButton = function () {
    this.button.enableButton(false);
  };

  button.showButton = function () {
    if (this.canShow()) {
      this.button.visible = true;
    } else {
      this.hideButton();
    }
  };

  button.hideButton = function () {
    this.button.visible = false;
  };

  button.setText = function (text) {
    if (this.button.setButtonText) {
      this.button.setButtonText(text);
    }
  };

  button.setTranslationPhrase = function (phrase) {
    if (this.button.setTranslationPhrase) {
      this.button.setTranslationPhrase(phrase);
    }
  };

  button.setTranslationParameters = function (args) {
    if (this.button.setTranslationParameters) {
      this.button.setTranslationParameters(args);
    }
  };

  button.playSound = function () {
    soundManager.play(button.soundName);
  };

  button.onPressedCallback = function () {};
  button.onReleasedCallback = function () {};

  button.registerButton = function (controller) {
    this.button = resourceManager.get(button.Props.FQN + ":button");
    this.button.onPressedCallback = this.onPressedCallback.bind(this);
    this.button.onReleasedCallback = this.onReleasedCallback.bind(this);
    controller.registerButton(this);
    messageBus.unsubscribe(
      "input:registerButtons",
      this.registerButton.bind(this)
    );
  };

  // This may be enabled later
  button._flags.allowSlamStop = false;

  button._flags.modal = {
    active: false,
    data: "",
  };
  button.modal = function (data) {
    if (data.reason !== undefined && data.reason !== "resume_game") {
      this._flags.modal = {
        active: true,
        data: data,
      };
    } else {
      this._flags.modal = {
        active: false,
        data: {
          reason: "",
        },
      };
    }
  };

  button.onGameConfig = function (config) {
    if (!config.data.slotConfig) {
      this._flags.allowSlamStop = false;
    } else {
      let allow =
        typeof config.data.slotConfig.allowSlamStop === "boolean"
          ? config.data.slotConfig.allowSlamStop
          : false;
      this._flags.allowSlamStop = allow;
    }
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onGameConfig.bind(button)
  );
  messageBus.subscribe(
    "input:registerButtons",
    button.registerButton.bind(button)
  );
  messageBus.subscribe("game:modal", button.modal.bind(button));
};

InputHelpers.addPayingWinsFlag = function (button) {
  button._flags.payingWins = false;

  button.doPayWins = function () {
    this._flags.payingWins = true;
  };

  button.doPayWinsEnd = function () {
    this._flags.payingWins = false;
  };

  messageBus.subscribe(
    "spinner:WinningLinesEvent",
    button.doPayWins.bind(button)
  );
  messageBus.subscribe(
    "spinner:WinningLinesEventDead",
    button.doPayWinsEnd.bind(button)
  );
};

InputHelpers.addSpinStartedFlag = function (button) {
  button._flags.reelsSpinning = false;

  button.reelSpinStarted = function (spinTask) {
    this._flags.reelsSpinning = true;
  };
  button.reelSpinEnded = function () {
    this._flags.reelsSpinning = false;
  };

  messageBus.subscribe(
    "spinner:SpinEvent",
    button.reelSpinStarted.bind(button)
  );
  messageBus.subscribe(
    "spinner:SpinEventDead",
    button.reelSpinEnded.bind(button)
  );
};
